module.exports = __webpack_public_path__ + "assets/img/18_1843_big.6a382045.jpg";